import React, { useState } from "react";
import Masonry from "react-masonry-css";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import AddressesEntity from "./AddressesEntity";
import AllergyEntity from "./AllergyEntity";
import BedAppointmentsEntity from "./BedAppointmentsEntity";
import CareModalityEntity from "./CareModalityEntity";
import ClientIdentifiersEntity from "./ClientIdentifiersEntity";
import ClientMedicationsEntity from "./ClientMedicationsEntity";
import ClientPayorEntity from "./ClientPayorEntity";
import ClientRateEntity from "./ClientRateEntity";
import ContactMethodsEntity from "./ContactMethodsEntity";
import DemographicsEntity from "./DemographicsEntity";
import FosterHomeBedEntity from "./FosterHomeBedEntity";
import ParentPartnerCountyEntity from "./ParentPartnerCountyEntity";
import PermanencyEntity from "./PermanencyEntity";
import ReferralEntity from "./ReferralEntity";
import ClientProgramIdentifierEntity from "./ClientProgramIdentifierEntity";
import VOCAEntity from "./VOCAEntity";
import FRCPSEntity from "./FRCPSEntity";
import DischargeChecklistModal from "./common/DischargeChecklistModal";
import UpdateRecordsModal from "./common/UpdateRecordsModal";
import { getFieldName, getFieldText } from "../scripts/helperScripts";
import schools from "../options/limaschools.json";
import CrisisReferralsEntity from "./CrisisReferralsEntity";
import CensusPayorEntity from "./CensusPayorEntity";

const ClientInfo = ({
  clientProgram,
  fosterHomePrograms,
  addresses,
  updateAddresses,
  beds,
  updateBeds,
  modalities,
  updateModalities,
  rates,
  updateRates,
  allergies,
  updateAllergies,
  medications,
  updateMedications,
  clientPayors,
  updateClientPayors,
  permanencyStatuses,
  updatePermanencyStatuses,
  bedAppointments,
  updateBedAppointments,
  recordedServices,
  updateCareTeam,
  existingCareTeam,
  clientIdentifiers,
  updateClientIdentifiers,
  clientProgramIdentifiers,
  loadClientProgramIdentifiers,
  referrals,
  showExpired,
  contact,
  updateDiagnosis,
}) => {
  const [addressBeingCreated, setAddressBeingCreated] = useState(false);
  const programConfig =
    Object.keys(clientProgram).length === 0
      ? { sections: [] }
      : clientProgram["unit.sor_safyportalconfig"] &&
        clientProgram["unit.sor_safyportalconfig"].length > 0
      ? JSON.parse(clientProgram["unit.sor_safyportalconfig"])
      : {
          sections: [
            "Demographics",
            "Addresses",
            "ClientPayors",
            "FosterBeds",
            "CareModalities",
            "BedAppointments",
            "ClientRates",
            "Allergies",
            "Medications",
            "PermanencyStatuses",
          ],
          fields: ["TEST"],
        };

  const openContact = () => {
    const url =
      process.env.REACT_APP_ORG +
      "/main.aspx?etc=2&extraqs=formid%3ddce13c2e-cc2a-4081-9921-df8dfaefcfac&id=" +
      clientProgram["con.contactid"] +
      "&pagetype=entityrecord";
    window.open(url, "contact");
  };

  return (
    <Card className="m-4 vw-50 card-safy" text="dark">
      <Card.Header className="bg-safy3-1 text-light">
        <div className="row">
          <div className="col-7 h5">
            <button
              style={{ cursor: "pointer" }}
              className="btn btn-link btn-light text-white"
              onClick={openContact}
            >
              {clientProgram["con.fullname"]}-{clientProgram["con.ccx_mpistr"]}
            </button>
            <div className="h6">
              {clientProgram["con.ccx_ssn"] &&
                `SSN: ${clientProgram["con.ccx_ssn"]}`}
            </div>
          </div>
          <div className="col-5">
            <div style={{ float: "right" }}>
              <DischargeChecklistModal
                clientId={clientProgram["con.contactid"]}
                clientProgram={clientProgram}
                recordedServices={recordedServices}
              ></DischargeChecklistModal>
              <UpdateRecordsModal
                clientId={clientProgram["con.contactid"]}
                clientProgram={clientProgram}
                fosterHomePrograms={fosterHomePrograms}
                updateAddresses={updateAddresses}
                updateAllergies={updateAllergies}
                updateClientPayors={updateClientPayors}
                modalities={modalities}
                updateModalities={updateModalities}
                updateRates={updateRates}
                updateCareTeam={updateCareTeam}
                updateMedications={updateMedications}
                updateDiagnosis={updateDiagnosis}
                updateBeds={updateBeds}
                updateBedAppointments={updateBedAppointments}
                existingCareTeam={existingCareTeam}
                addresses={addresses}
              ></UpdateRecordsModal>
              <Link
                title="Client Record"
                to={`/contact/${clientProgram["con.contactid"]}`}
                state={{ state: clientProgram["con.contactid"] }}
              >
                <i className="fas fa-pen float-end p-2 text-white"></i>
              </Link>
            </div>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="bg-safy1-3">
        {/* <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2"> */}
        <Masonry
          breakpointCols={{
            992: 2,
            991: 1,
          }}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {[
            <DemographicsEntity
              key="DemographicsEntity"
              contact={contact}
              businessUnitName={getFieldName(clientProgram.ccx_company)}
            ></DemographicsEntity>,
            ...(programConfig.sections
              ? programConfig.sections.map((section) => {
                  switch (section) {
                    // case "Demographics":
                    //   return (
                    //     <DemographicsEntity contact={contac</React.Fragment>t}></DemographicsEntity>
                    //   );
                    case "Addresses":
                      return (
                        <React.Fragment key="Addresses">
                          <AddressesEntity
                            key="AddressEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            addresses={addresses}
                            updateAddresses={updateAddresses}
                            showExpired={showExpired}
                            setAddressBeingCreated={setAddressBeingCreated}
                            contact={contact}
                          />
                        </React.Fragment>
                      );
                    case "Allergies":
                      return (
                        <React.Fragment key="Allergies">
                          <AllergyEntity
                            key="AllergyEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            allergies={allergies}
                            updateAllergies={updateAllergies}
                            showExpired={showExpired}
                          />
                        </React.Fragment>
                      );
                    case "CareModalities":
                      return (
                        <React.Fragment key="CareModalities">
                          <CareModalityEntity
                            key="CareModalityEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            fosterHomePrograms={fosterHomePrograms}
                            modalities={modalities}
                            updateModalities={updateModalities}
                            updateRates={updateRates}
                            showExpired={showExpired}
                            currentRate={rates[0]}
                          />
                        </React.Fragment>
                      );
                    case "ClientPayors":
                      return (
                        <React.Fragment key="ClientPayors">
                          <ClientPayorEntity
                            key="ClientPayorEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            clientPayors={clientPayors}
                            updateClientPayors={updateClientPayors}
                            updateAddresses={updateAddresses}
                            showExpired={showExpired}
                            addresses={addresses}
                            careTeam={existingCareTeam}
                            addressBeingCreated={addressBeingCreated}
                          />
                        </React.Fragment>
                      );
                    case "ClientRates":
                      return (
                        <React.Fragment key="ClientRates">
                          <ClientRateEntity
                            key="ClientRateEntity"
                            clientId={clientProgram["con.contactid"]}
                            rates={rates}
                            clientProgram={clientProgram}
                            fosterHomePrograms={fosterHomePrograms}
                            modalities={modalities}
                            updateModalities={updateModalities}
                            updateRates={updateRates}
                            showExpired={showExpired}
                            currentRate={rates[0]}
                          />
                        </React.Fragment>
                      );
                    case "FosterBeds":
                      return (
                        <React.Fragment key="FosterBeds">
                          <FosterHomeBedEntity
                            key="FosterHomeBedEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            beds={beds}
                            updateBeds={updateBeds}
                            showExpired={showExpired}
                          />
                        </React.Fragment>
                      );
                    case "Medications":
                      return (
                        <React.Fragment key="Medications">
                          <ClientMedicationsEntity
                            key="ClientMedicationEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            medications={medications}
                            showExpired={showExpired}
                            updateMedications={updateMedications}
                          />
                        </React.Fragment>
                      );
                    case "PermanencyStatuses":
                      return (
                        <React.Fragment key="PermanencyStatuses">
                          <PermanencyEntity
                            key="PermanencyStatusEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            permanencyStatuses={permanencyStatuses}
                            updatePermanencyStatuses={updatePermanencyStatuses}
                          ></PermanencyEntity>
                        </React.Fragment>
                      );
                    case "BedAppointments":
                      return (
                        <React.Fragment key="BedAppointments">
                          <BedAppointmentsEntity
                            key="BedAppointmentEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            bedAppointments={bedAppointments}
                            showExpired={showExpired}
                            updateBedAppointments={updateBedAppointments}
                          ></BedAppointmentsEntity>
                        </React.Fragment>
                      );
                    case "ClientIdentifiers":
                      return (
                        <React.Fragment key="ClientIdentifiers">
                          <ClientIdentifiersEntity
                            key="ClientIdentifierEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            clientIdentifiers={clientIdentifiers.filter(
                              (x) =>
                                x.ccx_clientidentifiertype?.["@name"] !==
                                  "VOCA" &&
                                x.ccx_clientidentifiertype?.["@name"] !==
                                  "FRCPS" &&
                                x.ccx_clientidentifiertype["@name"] !==
                                  "Cincinnati EF"
                            )}
                            showExpired={showExpired}
                            updateClientIdentifiers={updateClientIdentifiers}
                          ></ClientIdentifiersEntity>
                        </React.Fragment>
                      );
                    case "ContactMethods":
                      return (
                        <React.Fragment key="ContactMethods">
                          <ContactMethodsEntity
                            key="ContactMethodsEntity"
                            contact={contact}
                          ></ContactMethodsEntity>
                        </React.Fragment>
                      );
                    case "School":
                      return (
                        <React.Fragment key="School">
                          <ClientProgramIdentifierEntity
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            showExpired={showExpired}
                            clientProgramIdentifiers={clientProgramIdentifiers.filter(
                              (identifier) =>
                                getFieldText(
                                  identifier.ccx_clientprogramidentifiertype
                                ) === "186460000"
                            )}
                            loadClientProgramIdentifiers={
                              loadClientProgramIdentifiers
                            }
                            entityTitle="School Identifiers"
                            modalTitle="School Identifier"
                            identifierType="186460000"
                            identifierLabel="School"
                            identifierToastLabel="School Identifier"
                            identifierOptions={schools.schools}
                          ></ClientProgramIdentifierEntity>
                        </React.Fragment>
                      );
                    case "CinciEF":
                      return (
                        <React.Fragment key="CinciEF">
                          <ClientProgramIdentifierEntity
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            showExpired={showExpired}
                            clientProgramIdentifiers={clientProgramIdentifiers.filter(
                              (identifier) =>
                                getFieldText(
                                  identifier.ccx_clientprogramidentifiertype
                                ) === "186460004"
                            )}
                            loadClientProgramIdentifiers={
                              loadClientProgramIdentifiers
                            }
                            entityTitle="Cincinnati EF Identifiers"
                            modalTitle="Cincinnati EF Identifier"
                            identifierType="186460004"
                            identifierLabel="Identifier"
                            identifierToastLabel="Identifier"
                            identifierOptions={[
                              { _id: "IHBT", name: "IHBT" },
                              { _id: "Hamilton JFS", name: "Hamilton JFS" },
                            ]}
                          ></ClientProgramIdentifierEntity>
                        </React.Fragment>
                      );
                    case "ParentPartnerCounty":
                      return (
                        <React.Fragment key="ParentPartnerIdendifier">
                          <ParentPartnerCountyEntity
                            key="ParentPartnerIdentifierEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            showExpired={showExpired}
                          ></ParentPartnerCountyEntity>
                        </React.Fragment>
                      );
                    case "Referral":
                      return (
                        <React.Fragment key="Referral">
                          <ReferralEntity
                            referrals={referrals}
                          ></ReferralEntity>
                        </React.Fragment>
                      );
                    case "VOCA":
                      return (
                        <React.Fragment key="VOCA">
                          <VOCAEntity
                            key="ClientIdentifierEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            clientIdentifiers={clientIdentifiers.filter(
                              (x) =>
                                x.ccx_clientidentifiertype?.["@name"] === "VOCA"
                            )}
                            showExpired={showExpired}
                            updateClientIdentifiers={updateClientIdentifiers}
                          ></VOCAEntity>
                        </React.Fragment>
                      );
                    case "FRCPS":
                      return (
                        <React.Fragment key="FRCPS">
                          <FRCPSEntity
                            key="ClientIdentifierEntity"
                            clientId={clientProgram["con.contactid"]}
                            clientProgram={clientProgram}
                            clientIdentifiers={clientIdentifiers.filter(
                              (x) =>
                                x.ccx_clientidentifiertype?.["@name"] ===
                                "FRCPS"
                            )}
                            showExpired={showExpired}
                            updateClientIdentifiers={updateClientIdentifiers}
                          ></FRCPSEntity>
                        </React.Fragment>
                      );
                    case "Crisis Referrals":
                      return (
                        <React.Fragment key="MCRefferals">
                          <CrisisReferralsEntity
                            clientId={clientProgram["con.contactid"]}
                          />{" "}
                        </React.Fragment>
                      );
                    default:
                      return null;
                  }
                })
              : []),
            <CensusPayorEntity
              key="ClientCensusPayorEntity"
              client={{
                id: clientProgram["con.contactid"],
                name: clientProgram.ccx_patient["@name"],
              }}
              clientProgram={clientProgram}
              showExpired={showExpired}
            />,
          ]}
        </Masonry>
        {/* </div> */}
        <br />
        <br />
        <div></div>
      </Card.Body>
    </Card>
  );
};

export default ClientInfo;
